export const globalSettingsIssuesFieldlayoutsEditRoute = {
	name: 'global-settings-issues-fieldlayouts-edit',
	path: '/secure/admin/EditFieldLayout!default.jspa',
};
